import { Clear } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import { useWatch } from 'react-hook-form';
import IncTextField from '../inc-text-field/inc-text-field.component';

type KeyValueItemProps = {
  name: string;
  remove: () => void;
};

const KeyValueItem = ({ name, remove }: KeyValueItemProps) => {
  const key = useWatch({ name: `${name}.key` });

  return (
    <Stack direction="row" alignItems="center">
      <IncTextField
        name={`${name}.value`}
        label={key}
        margin="none"
        data-testid="KeyValueItem.IncTextField"
      />
      <IconButton onClick={remove} data-testid="KeyValueItem.CloseIcon">
        <Clear color="error" />
      </IconButton>
    </Stack>
  );
};
export default KeyValueItem;
